import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ConfirmacionPagoPowerpay } from '../componets/powerpay';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { DefaultButton, Label } from 'office-ui-fabric-react';

import Common from '../componets/Common';
import { obtenerPagoPowerpay } from '../helpers';

const getMensajePago = (status) => {
  if(status === "PROCESSED") return "Su pago se ha realizado con éxito.";
  
  if(status === "EXPIRED") return "Lo sentimos, la transacción expiró.";
  
  if(status === "CANCELED") return "Lo sentimos, el pago ha sido denegado.";

  return "Su pago se ha realizado con éxito.";
}

export const ResponsePowerpayPage = () => {  

  const [showLoading, setShowLoading] = useState(true);
  const [mensajePago, setMensajePago] = useState("")
  const [searchParams] = useSearchParams();  
  const status = searchParams.get('status');
  const external_id = searchParams.get('external_id');
  
  useEffect(() => {
    if(status.toUpperCase() !== "PENDING") setShowLoading(false);

    const mensaje = getMensajePago(status.toUpperCase());
    setMensajePago(mensaje);

  }, [status])

  const mostrarCargando = (isLoading) => setShowLoading(isLoading);

  const handleImprimir = () => window.print();

  const handleContinuar = async () => {    
    setShowLoading(true);
    const obtenerPago = await obtenerPagoPowerpay(external_id);

    if(!!obtenerPago.mensajeError){
      setShowLoading(false);
    }else{      
      if (obtenerPago.detail.codigotop === "CE") {
        window.location = `${Common.CERTIFIKATE_URL}/pagos/datos/${obtenerPago.detail.idcertifikate}`;
      } else if (
        obtenerPago.detail.codigotop === "ES" ||
        obtenerPago.detail.codigotop === "RC" ||
        obtenerPago.detail.codigotop === "RS" ||
        obtenerPago.detail.codigotop === "PP" ||
        obtenerPago.detail.codigotop === "PM" ||
        obtenerPago.detail.codigotop === "RX" ||
        obtenerPago.detail.codigotop === "TC"
      ) {
        if (obtenerPago.detail.codigotop === "PM" || obtenerPago.detail.codigotop === "PP") {
          window.location = `${Common.URLMooestroPortalAlumnos}/finance?mId=finance&eId=economicDetails`;
        } else if (obtenerPago.codigotop === "TC") {
          window.location = `${Common.URLMooestroPortalAlumnos}/requests-data/2`;
        } else if (
          obtenerPago.detail.codigotop === "RC" ||
          obtenerPago.detail.codigotop === "RX"
        ) {
          window.location = `${Common.URLMooestroPortalAlumnos}/requests-data/4`;
        } else if (obtenerPago.detail.codigotop === "ES") {
          window.location = `${Common.URLMooestroPortalAlumnos}/requests-data/5`;
        } else {
          window.location = `${Common.URLMooestroPortalAlumnos}/resquests-data/1`;
        }
      } else {
        window.location = `${Common.PORTAL_TRAMITES_UPN_URL}`;
      }
    }
  }

  return (
    <>
      {showLoading ? <div className="preloader"></div> : null}
      <Grid style={{ padding: "2rem 5rem" }}>
        <Row middle="xs" className="card">
          <Col xs={12} sm={12} className="container">
            <Row style={{ justifyContent: "Center" }}>
              <Col xs={12} sm={3} style={{ display:"flex", justifyContent: "Center", maxHeight: "160px" }}>
                <img                
                  src="https://upn-repositorio-public.s3.amazonaws.com/logos/png/logo-upn-sin-fondo.png"
                  style={{objectFit: "cover", width:"50vw", height:"100%"}}
                  alt="logo"
                ></img>
              </Col>
            </Row>

            <Row center="xs">
              <Col xs={12} sm={12}>
                <Label
                  style={{
                    fontWeight: "bold",
                    color: status.toUpperCase() === "PROCESSED" ? "green" : "red"
                  }}
                >
                  {mensajePago}
                </Label>
              </Col>
            </Row>
            <Row center="xs">
              <Col xs={12} sm={3}>
                <Label style={{ fontWeight: "bold" }}>
                  Nro. pedido: {external_id}
                </Label>
              </Col>
            </Row>

            {status.toUpperCase() === "PROCESSED" && <ConfirmacionPagoPowerpay mostrarCargando={mostrarCargando} />}            

            <br></br>
            <Row center="xs">
              <Col xs={12} sm={12}>
                <span
                  style={{
                    fontStyle: "italic",
                    fontSize: "0.5rem !important"
                  }}
                >
                  * Se recomienda capturar o imprimir esta pantalla
                </span>
              </Col>
            </Row>
            <br></br>
            <Row center="xs">
              <Col xs={12} sm={3}>
                <DefaultButton
                  className="btn-primary"
                  style={{minWidth:"100%"}}
                  text="Continuar"
                  onClick={handleContinuar}
                ></DefaultButton>
              </Col>
              &nbsp; &nbsp;
              <Col xs={12} sm={3}>
                <DefaultButton
                  className="btn-primary"
                  style={{minWidth:"100%"}}
                  text="Imprimir"
                  onClick={handleImprimir}
                ></DefaultButton>
              </Col>
            </Row>
            <br></br>
            <hr></hr>
            <br></br>
            <Row center="xs">
              <Col xs={12} sm={12}>
                Universidad Privada del Norte - 2020
              </Col>
            </Row>
            <br></br>
          </Col>
        </Row>
      </Grid>
    </>
  )
}
